import * as React from 'react';

export const IconSlimCheck = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		fill="currentColor"
		version="1.1"
		viewBox="0 0 1200 1200"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			id="SlimCheckIcon-Original"
			fill="currentColor"
			d="m938.4 350.4-453.6 447.6-222-238.8c-4.1484-4.8633-10.148-7.7656-16.535-7.9922-6.3906-0.22656-12.582 2.2383-17.066 6.793-4.8633 4.1484-7.7656 10.148-7.9922 16.535-0.22656 6.3906 2.2383 12.582 6.793 17.066l237.6 256.8c4.5938 5.1484 11.102 8.1836 18 8.4023 6.3281-0.089843 12.367-2.6797 16.797-7.1992l471.6-464.4c4.4766-4.6875 6.9727-10.918 6.9727-17.398s-2.4961-12.715-6.9727-17.402c-4.3164-4.7031-10.414-7.3828-16.801-7.3828s-12.48 2.6797-16.801 7.3828z"
		/>
	</svg>
);
